import * as React from 'react'
import Stepper from '@mui/material/Stepper'
import Step from '@mui/material/Step'
import StepLabel from '@mui/material/StepLabel'
import { useLocation } from 'react-router-dom'
import VendorWizardConnector from 'vendors/vendorWizard/components/VendorWizardStepConnector'
import VendorWizardStepIcon from 'vendors/vendorWizard/components/VendorWizardStepIcon'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useTheme } from '@mui/material/styles'
import Box from '@mui/material/Box'
import MobileStepper from '@mui/material/MobileStepper'

const VendorWizardStepper: React.FC<{ steps: WizardStep[] }> = ({ steps }) => {
  const { pathname } = useLocation()
  const theme = useTheme()
  const isWidescreen = useMediaQuery(theme.breakpoints.up('sm'))

  const activeStepIndex = React.useMemo(() => {
    const activeStepIndex = steps.findIndex((step) => pathname.includes(step.step))
    return activeStepIndex
  }, [pathname, steps])

  return (
    <>
      {isWidescreen ? (
        <>
          <Stepper
            sx={{
              pt: 2,
              pb: 2,
              backgroundColor: 'common.white',
              position: 'fixed',
              top: '64px',
              width: '100%',
              zIndex: 2,
              whiteSpace: 'nowrap'
            }}
            activeStep={activeStepIndex}
            alternativeLabel
            connector={<VendorWizardConnector />}
          >
            {steps.map((step) => (
              <Step key={step.step}>
                <StepLabel StepIconComponent={VendorWizardStepIcon}>{step.label}</StepLabel>
              </Step>
            ))}
          </Stepper>
          <Box sx={{ mt: 16 }} />
        </>
      ) : (
        <>
          <MobileStepper
            variant="dots"
            steps={5}
            activeStep={activeStepIndex}
            nextButton={null}
            backButton={null}
            sx={{
              pt: 2,
              pb: 3,
              backgroundColor: 'common.white',
              position: 'fixed',
              top: '55px',
              width: '100%',
              zIndex: 2,
              height: 'min-content',
              justifyContent: 'center'
            }}
          />
          <Box sx={{ mt: 5 }} />
        </>
      )}
    </>
  )
}

export default VendorWizardStepper
